module.exports = __webpack_public_path__ + "static/media/eight-pcs-box__square.9906fc4f.png";